import { render, staticRenderFns } from "./CareersJob.vue?vue&type=template&id=054d960e"
import script from "./CareersJob.vue?vue&type=script&lang=js"
export * from "./CareersJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports